import React from 'react';

/**
 * Pins the course header row (back pill + progress bar) to the top of the
 * viewport while the learner scrolls the page content, so the completion
 * percentage is always visible.
 *
 * The translucent backdrop-blur keeps scrolled content readable underneath
 * the floating percent chip without a hard edge; `-mx-2 px-2` gives the
 * blur a little bleed past the row so pills never sit half-on/half-off it.
 */
export default function StickyProgressRow({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  // Each layout declares where "top" is (AppLayout sets --sticky-top to its
  // header height; immersive layouts leave it at 0), so the row pins below
  // whatever chrome the current shell has instead of sliding behind it.
  return (
    <div
      className={`sticky top-[var(--sticky-top,0px)] z-30 -mx-2 px-2 py-2 rounded-b-2xl bg-background-primary/85 backdrop-blur-md ${className}`}
    >
      {children}
    </div>
  );
}
